import {Component, forwardRef, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {CategorySimpleSearchModel} from "../category-simple-search.model";
import {CategorySearchPageComponent} from "../category-search-page/category-search-page.component";
import {CategoryEditPageComponent} from "../category-edit-page/category-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-category-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(CategorySingleSelectEditControlComponent),
        provideSearchModel(CategorySimpleSearchModel)
    ]
})
export class CategorySingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<CategorySimpleSearchModel> {
    constructor(model: CategorySimpleSearchModel, injector: Injector) {
        super(model, injector, "categoryId", "name");

        this.extendedSearchComponent = CategorySearchPageComponent;
        this.extendedEditComponent = CategoryEditPageComponent;
    }
}
